export default {
  placeholder: 'Szukaj',
  cancel: 'Anuluj',
};
